/**
 * React Query hook for inspection status data
 */
import { useQuery } from '@tanstack/react-query';
import InspectionStatusService from './InspectionStatusService';
export const INSPECTION_STATUSES_QUERY_KEY = ['inspection-statuses'];
/**
 * Hook to fetch all inspection statuses
 */
export function useInspectionStatuses(enabled = true) {
    return useQuery({
        queryKey: INSPECTION_STATUSES_QUERY_KEY,
        queryFn: () => InspectionStatusService.getInspectionStatuses(),
        staleTime: 10 * 60 * 1000, // 10 minutes - statuses don't change often
        retry: 3,
        retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
        enabled
    });
}
